import React from 'react';
import { FormattedDate } from 'react-intl';

import useFormatTimeTimeZone from 'hooks/useFormatTimeTimeZone';
import { DATE_FORMAT } from 'utils/dateFormats';

type DateStandardCommonProps = {
  dealerId?: string;
  systemTimezone?: boolean;
};

export type StandardDateProps = Pick<React.ComponentProps<typeof FormattedDate>, 'value'> & DateStandardCommonProps;

const StandardDate: React.FC<StandardDateProps> = ({ value, dealerId, systemTimezone }) => {
  const timeZoneProps = useFormatTimeTimeZone({ dealerId, systemTimezone });
  if (!value) {
    return null;
  }
  return (
    // eslint-disable-next-line no-restricted-syntax
    <FormattedDate value={value} {...DATE_FORMAT} {...timeZoneProps} />
  );
};

export default StandardDate;
